(function (scope) {
  'use strict';
  function normalise(value) {
    return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  }
  var directions = {
    clean: ['fris', 'citrus', 'bergamot', 'citroen', 'limoen', 'musk', 'muskus', 'thee', 'lavendel', 'aldehyde'],
    fruit: ['fruitig', 'appel', 'peer', 'mango', 'perzik', 'ananas', 'passievrucht', 'mandarijn', 'sinaasappel', 'bes'],
    warm: ['gourmand', 'vanille', 'karamel', 'koffie', 'tonka', 'cacao', 'chocolade', 'honing', 'amandel'],
    green: ['houtachtig', 'groen', 'vetiver', 'ceder', 'sandelhout', 'dennen', 'mos', 'vijg', 'galbanum'],
    floral: ['bloemig', 'roos', 'jasmijn', 'iris', 'viooltje', 'pioen', 'oranjebloesem', 'tuberoos', 'ylang']
  };
  function matches(text, words) {
    return words.reduce(function (sum, word) {
      return sum + (new RegExp('(?:^|[^a-z])' + word + '(?:[a-z]*)(?=$|[^a-z])').test(text) ? 1 : 0);
    }, 0);
  }
  function profile(product) {
    var text = normalise([product.families, product.notes].join(' '));
    var scores = {};
    Object.keys(directions).forEach(function (key) { scores[key] = Math.min(3, matches(text, directions[key])); });
    var projection = normalise(product.projection);
    return {
      directions: scores,
      main: Object.keys(scores).sort(function (a, b) { return scores[b] - scores[a]; })[0],
      presence: projection === 'licht' ? 1 : (projection === 'gemiddeld' ? 2 : (projection === 'sterk' ? 3 : 0)),
      unusual: Math.min(3, matches(text, ['rook', 'rokerig', 'wierook', 'leer', 'oud', 'agarhout', 'teer', 'civet', 'castoreum']))
    };
  }
  function values(value) { return Array.isArray(value) ? value : (value ? [value] : []); }
  function noteList(value) {
    var seen = new Set();
    return (Array.isArray(value) ? value : String(value || '').split(/[·|;,\n]+/)).map(function (note) { return String(note).trim(); }).filter(function (note) {
      var key = normalise(note); if (!key || seen.has(key)) return false; seen.add(key); return true;
    });
  }
  function notesFor(product) {
    var groups = product.noteGroups || {};
    var lanes = [noteList(groups.top), noteList(groups.heart), noteList(groups.base)];
    var featured = [];
    for (var i = 0; i < 2; i++) lanes.forEach(function (lane) { if (lane[i]) featured.push(lane[i]); });
    if (!featured.length) featured = noteList(groups.notes || product.notes);
    return { featured:noteList(featured).slice(0,6), groups:lanes, all:noteList(lanes.flat().concat(noteList(groups.notes || (lanes.flat().length ? '' : product.notes)))) };
  }
  function baseScore(product, answers) {
    var p = profile(product), moods = answers.mood || ['any'];
    var score = 0;
    moods.forEach(function (mood) { score += (p.directions[mood] || 0) * 3; });
    var occasions = values(answers.occasion), presence = values(answers.presence);
    if (occasions.includes('day') || occasions.includes('work')) score += p.directions.clean + p.directions.green * 0.4;
    if (occasions.includes('evening')) score += p.directions.warm + p.directions.floral * 0.4;
    if (presence.includes('soft')) score += p.presence === 1 ? 4 : (p.presence === 2 ? 1 : -2);
    if (presence.includes('balanced')) score += p.presence === 2 ? 3 : 0;
    if (presence.includes('bold')) score += p.presence === 3 ? 4 : 0;
    if (answers.adventure === 'familiar') score -= p.unusual * 3;
    if (answers.adventure === 'discover') score += p.unusual * 1.5;
    score += Math.min(1, Math.log1p(Math.max(0, Number(product.choiceCount) || 0)) / 5);
    return score;
  }
  function eligible(product, answers) {
    return product.available === true && !product.storeExclusive &&
      !(values(answers.presence).length === 1 && values(answers.presence)[0] === 'soft' && profile(product).presence === 3);
  }
  function rank(products, answers, picked) {
    return products.map(function (product) {
      var p = profile(product), score = baseScore(product, answers);
      var sameBrand = picked.filter(function (item) { return normalise(item.brand) === normalise(product.brand); }).length;
      var sameDirection = picked.filter(function (item) { return profile(item).main === p.main; }).length;
      score -= sameBrand * 2.5 + Math.max(0, sameBrand - 1) * 6;
      score -= sameDirection * 1.75;
      var requestedPresence = values(answers.presence).map(function (value) { return {soft:1,balanced:2,bold:3}[value]; });
      if (requestedPresence.length > 1 && requestedPresence.includes(p.presence) && !picked.some(function (item) { return profile(item).presence === p.presence; })) score += 5;
      (answers.mood || []).forEach(function (mood) {
        if (p.directions[mood] && !picked.some(function (item) { return profile(item).directions[mood] > 0; })) score += 4;
      });
      return { product: product, score: score };
    }).sort(function (a, b) { return b.score - a.score || String(a.product.id).localeCompare(String(b.product.id)); });
  }
  function selectFive(products, answers, allowedPremiumCounts) {
    var seen = new Set();
    var pool = products.filter(function (p) {
      if (!p.id || seen.has(p.id) || !eligible(p, answers)) return false;
      seen.add(p.id); return true;
    });
    var limit = Number(answers.premium || 0), best = null;
    (allowedPremiumCounts || [0, 1, 2, 3, 4, 5]).forEach(function (target) {
      if (target > limit || target < 0 || target > 5) return;
      if (pool.filter(function (p) { return p.premium; }).length < target || pool.filter(function (p) { return !p.premium; }).length < 5 - target) return;
      var picked = [], score = 0;
      while (picked.length < 5) {
        var premiumPicked = picked.filter(function (p) { return p.premium; }).length;
        var ranked = rank(pool.filter(function (p) {
          return !picked.includes(p) && (p.premium ? premiumPicked < target : picked.length - premiumPicked < 5 - target);
        }), answers, picked);
        if (!ranked.length) break;
        picked.push(ranked[0].product); score += ranked[0].score;
      }
      if (picked.length === 5 && (!best || score > best.score)) best = { items: picked, score: score };
    });
    return best ? best.items : [];
  }
  function replacement(products, answers, picked, index, allowedPremiumCounts) {
    var keep = picked.filter(function (_, i) { return i !== index; });
    var count = keep.filter(function (p) { return p.premium; }).length;
    var candidates = products.filter(function (p) {
      var total = count + (p.premium ? 1 : 0);
      return eligible(p, answers) && !picked.some(function (item) { return item.id === p.id; }) && total <= Number(answers.premium || 0) && allowedPremiumCounts.includes(total);
    });
    return (rank(candidates, answers, keep)[0] || {}).product || null;
  }
  function mount(options) {
    var root = options.root, dialog = root.querySelector('[data-guide]'), launch = root.querySelector('[data-guide-open]');
    if (!dialog || !launch || typeof dialog.showModal !== 'function') return;
    var copy;
    try { copy = JSON.parse(root.querySelector('[data-guide-copy]').textContent); } catch (_) { return; }
    var nl=(document.documentElement.lang||'nl').startsWith('nl');
    Object.assign(copy,nl?{
      premium_title:'Mogen er samples met een toeslag bij?',premium_sub:'Sommige sampletypes hebben een toeslag. Je ziet de exacte prijs bij je voorstel.',
      premium_0:'Zonder toeslag',premium_0_sub:'Alleen samples die bij de basisprijs zijn inbegrepen.',
      premium_2:'Maximaal 2 samples met toeslag',premium_2_sub:'Tot {extra} extra, afhankelijk van de gekozen geuren.',
      premium_5:'Alle sampletypes',premium_5_sub:'Tot {extra} extra. De prijs volgt uit je selectie.',
      premium_label:'Sample met toeslag',premium_included:'samples met toeslag',premium_included_one:'sample met toeslag'
    }:{premium_title:'May we include samples with a surcharge?',premium_sub:'Some sample types cost extra. Your proposal shows the exact total.',
      premium_0:'No surcharge',premium_0_sub:'Only samples included in the base price.',premium_2:'Up to 2 samples with a surcharge',premium_2_sub:'Up to {extra} extra, depending on the fragrances.',
      premium_5:'All sample types',premium_5_sub:'Up to {extra} extra. The total depends on your selection.',premium_label:'Sample with surcharge',premium_included:'samples with surcharge',premium_included_one:'sample with surcharge'});
    var t = function (key) { return copy[key] || ''; };
    var e = function (value) { return String(value || '').replace(/[&<>"']/g, function (c) { return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c]; }); };
    var grid = root.querySelector('[data-self-grid]'), sort = root.querySelector('[data-self-sort]');
    var sortTrigger = sort.querySelector('summary'), sortLabel = sort.querySelector('[data-sort-label]');
    var sortOptions = Array.from(sort.querySelectorAll('[data-sort-value]')), sortValue = 'default';
    var availableOnly = root.querySelector('[data-self-available]'), onlyAvailable = false;
    var status = root.querySelector('[data-self-status]'), body = dialog.querySelector('[data-guide-body]');
    var notice = dialog.querySelector('[data-guide-notice]'), back = dialog.querySelector('[data-guide-back]');
    var next = dialog.querySelector('[data-guide-next]'), progress = dialog.querySelector('[data-guide-progress]');
    var stepLabel = dialog.querySelector('[data-guide-step]'), journey = dialog.querySelector('[data-guide-journey]');
    var hint = dialog.querySelector('[data-guide-hint]');
    var steps = [
      {id:'mood', choices:['clean','fruit','warm','green','floral','any'], multi:true},
      {id:'occasion', choices:['day','work','evening','any'], multi:true},
      {id:'presence', choices:['soft','balanced','bold','any'], multi:true},
      {id:'adventure', choices:['familiar','mix','discover']},
      {id:'premium', choices:['0','2','5']}
    ];
    var step = 0, furthest = 0, answers = {}, result = [], lastFocus = null;
    var originalCards = Array.from(grid.querySelectorAll('[data-card]'));
    var originalOrder = new Map(originalCards.map(function (card, index) { return [card, index]; }));
    var inventoryReady = function () { return root.getAttribute('data-orn-sample-inventory-state') === 'ready'; };
    function products() {
      return originalCards.map(function (card) {
        var noteGroups = {};
        try { noteGroups = JSON.parse(card.getAttribute('data-guide-note-groups') || '{}'); } catch (_) {}
        return {
          id:card.getAttribute('data-id'), title:card.getAttribute('data-title'),
          brand:(card.querySelector('.oga-card__brand') || {}).textContent || '',
          families:card.getAttribute('data-fams') || '', notes:card.getAttribute('data-guide-notes') || '', noteGroups:noteGroups,
          projection:card.getAttribute('data-projection') || '', choiceCount:Number(card.getAttribute('data-choice-count')) || 0,
          available:card.getAttribute('data-locked') === 'false' && card.getAttribute('data-orn-sample-db-state') === 'ready',
          surcharge:Number(card.getAttribute('data-surcharge'))||0,typeName:card.getAttribute('data-sample-type-name')||'',
          storeExclusive:card.getAttribute('data-store') === 'true', premium:card.getAttribute('data-premium') === 'true', card:card
        };
      });
    }
    function allowedCounts() { return [0,1,2,3,4,5]; }
    function money(cents) { return new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', {style:'currency',currency:'EUR',maximumFractionDigits:2}).format(cents / 100); }
    function closeSort(restoreFocus) { sort.open = false; if (restoreFocus) sortTrigger.focus(); }
    function updateCatalog() {
      var hasPopularity = originalCards.some(function (card) { return card.hasAttribute('data-choice-count') && card.getAttribute('data-choice-count') !== ''; });
      sortOptions.forEach(function (button) { button.disabled = button.dataset.sortValue === 'popular' && !hasPopularity; });
      if (sortValue === 'popular' && !hasPopularity) sortValue = 'default';
      sortOptions.forEach(function (button) {
        var selected = button.dataset.sortValue === sortValue;
        button.setAttribute('aria-selected', String(selected));
        if (selected) sortLabel.textContent = button.textContent;
      });
      var byCard = new Map(products().map(function (p) { return [p.card,p]; }));
      var cards = originalCards.slice().sort(function (a,b) {
        var left = byCard.get(a), right = byCard.get(b);
        if (sortValue === 'popular') return right.choiceCount - left.choiceCount || originalOrder.get(a) - originalOrder.get(b);
        if (sortValue === 'name') return left.title.localeCompare(right.title,'nl',{sensitivity:'base'});
        if (sortValue === 'brand') return left.brand.localeCompare(right.brand,'nl',{sensitivity:'base'}) || left.title.localeCompare(right.title,'nl');
        return originalOrder.get(a) - originalOrder.get(b);
      });
      cards.forEach(function (card) { grid.appendChild(card); });
      root.dispatchEvent(new CustomEvent('ornata:sample-filter-change'));
      if (onlyAvailable) cards.forEach(function (card) { if (!byCard.get(card).available) card.style.display = 'none'; });
      var visible = cards.filter(function (card) { return card.style.display !== 'none'; }).length;
      status.textContent = visible === 0 ? t('no_matches') : visible + ' ' + t('fragrances') + (sortValue === 'popular' ? ' · ' + t('popularity_note') : '');
    }
    sort.addEventListener('toggle', function () { sortTrigger.setAttribute('aria-expanded',String(sort.open)); });
    sortOptions.forEach(function (button) { button.addEventListener('click',function () { sortValue = button.dataset.sortValue; updateCatalog(); closeSort(true); }); });
    sort.addEventListener('keydown',function (event) {
      if (event.key === 'Escape' && sort.open) { event.stopPropagation(); event.preventDefault(); closeSort(true); return; }
      if (!['ArrowDown','ArrowUp','Home','End'].includes(event.key)) return;
      event.preventDefault(); sort.open = true;
      var enabled = sortOptions.filter(function (button) { return !button.disabled; });
      var index = enabled.indexOf(document.activeElement);
      if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = enabled.length - 1;
      else index = (index + (event.key === 'ArrowDown' ? 1 : -1) + enabled.length) % enabled.length;
      enabled[index].focus();
    });
    document.addEventListener('click',function (event) { if (!sort.contains(event.target)) closeSort(false); });
    // Touch browsers can blur the summary without focusing the tapped option.
    // Keep the options mounted until its click has selected the new ordering.
    sort.addEventListener('focusout',function (event) { if (event.relatedTarget && !sort.contains(event.relatedTarget)) closeSort(false); });
    availableOnly.addEventListener('click',function () { onlyAvailable = !onlyAvailable; availableOnly.setAttribute('aria-pressed',String(onlyAvailable)); updateCatalog(); });
    function setNotice(message) { notice.textContent = message || ''; notice.hidden = !message; }
    function focusHeading() { var h = body.querySelector('h2'); if (h) h.focus({preventScroll:true}); body.scrollTop = 0; }
    function answerLabels() {
      return steps.slice(0,3).flatMap(function (s) { return values(answers[s.id]).filter(function (v) { return v !== 'any'; }).map(function (v) { return {step:s.id,label:t(s.id+'_'+v)}; }); });
    }
    function summaryMarkup() {
      var labels = answerLabels();
      return '<aside class="oga-guide__reflection"><span>'+e(t('your_direction'))+'</span><div>'+ (labels.length ? labels.map(function (label) {return '<span>'+e(label.label)+'</span>';}).join('') : '<p>'+e(t('direction_empty'))+'</p>')+'</div></aside>';
    }
    function updateAnswers() {
      var current = steps[step], chosen = values(answers[current.id]);
      body.querySelectorAll('[data-guide-answer]').forEach(function (button) {
        var selected = chosen.includes(button.dataset.guideAnswer);
        button.setAttribute('aria-pressed',String(selected));
        button.querySelector('.oga-guide__check').textContent = selected ? '✓' : '+';
      });
      next.disabled = chosen.length === 0;
      hint.textContent = chosen.length ? (current.multi ? chosen.length+' '+t('selected_hint') : t('one_selected_hint')) : (current.multi ? t('multiple_hint') : t('single_hint'));
      var reflection = body.querySelector('.oga-guide__reflection');
      if (reflection) reflection.outerHTML = summaryMarkup();
    }
    function renderJourney() {
      journey.innerHTML = steps.map(function (s,i) {
        return '<button type="button" data-guide-jump="'+i+'"'+(i>furthest?' disabled':'')+(step===i?' aria-current="step"':'')+'><span>'+String(i+1).padStart(2,'0')+'</span>'+e(t(s.id+'_chapter'))+'</button>';
      }).join('');
      stepLabel.textContent = step < steps.length ? String(step+1).padStart(2,'0')+' / 05' : t('your_selection');
      progress.style.width = (Math.min(Math.max(step,0),steps.length) / steps.length * 100)+'%';
    }
    function render() {
      setNotice(''); renderJourney();
      dialog.dataset.stage = step === steps.length ? 'result' : steps[step].id;
      back.hidden = step === 0; back.textContent = step === steps.length ? t('edit_answers') : t('back');
      next.hidden = false; next.disabled = false;
      next.classList.toggle('button', step === steps.length);
      next.classList.toggle('link', step !== steps.length);
      if (step === steps.length) { renderResult(); return; }
      var current = steps[step];
      body.innerHTML = '<div class="oga-guide__chapter"><header class="oga-guide__heading"><span class="oga-guide__eyebrow">'+e(t(current.id+'_chapter'))+'</span><h2 tabindex="-1">'+e(t(current.id+'_title'))+'</h2><p class="oga-guide__sub">'+e(t(current.id+'_sub'))+'</p><span class="oga-guide__instruction">'+e(current.multi?t('multiple_hint'):t('single_hint'))+'</span></header><div class="oga-guide__options" role="group" aria-label="'+e(t(current.id+'_title'))+'">'+current.choices.map(function (choice,index) {
        var detail = t(current.id+'_'+choice+'_sub');
        if (current.id === 'premium') detail = detail.replace('{extra}',money(Number(choice)*options.maximumSurcharge()));
        return '<button type="button" class="oga-guide__option'+(choice==='any'?' oga-guide__option--open':'')+'" data-guide-answer="'+choice+'" data-scene="'+current.id+'-'+choice+'" aria-pressed="false" style="--i:'+index+'"><span class="oga-guide__option-number" aria-hidden="true">'+(choice==='any'?'…':String(index+1).padStart(2,'0'))+'</span><span class="oga-guide__option-title">'+e(t(current.id+'_'+choice))+'</span><small>'+e(detail)+'</small><span class="oga-guide__check" aria-hidden="true">+</span></button>';
      }).join('')+'</div>'+summaryMarkup()+'</div>';
      next.textContent = step === steps.length-1 ? t('show_result') : t('next'); updateAnswers();
    }
    function noteMarkup(item) {
      var notes = notesFor(item), labels = ['top_notes','heart_notes','base_notes'];
      if (!notes.featured.length) return '<p class="oga-guide__notes">'+e(noteList(item.families).join(' · '))+'</p>';
      var html = '<p class="oga-guide__notes"><span>'+e(t('notes_label'))+'</span>'+e(notes.featured.join(' · '))+'</p>';
      if (notes.all.length > notes.featured.length || notes.groups.some(function (lane) {return lane.length;})) {
        html += '<details class="oga-guide__note-detail"><summary class="link">'+e(t('all_notes'))+'</summary><dl>';
        notes.groups.forEach(function (lane,index) { if (lane.length) html += '<div><dt>'+e(t(labels[index]))+'</dt><dd>'+e(lane.join(' · '))+'</dd></div>'; });
        if (!notes.groups.some(function (lane) {return lane.length;})) html += '<div><dd>'+e(notes.all.join(' · '))+'</dd></div>';
        html += '</dl></details>';
      }
      return html;
    }
    function renderResult() {
      var premium = result.filter(function (item) {return item.premium;}).length, variant = options.getVariant(result);
      dialog.dataset.stage = 'result';
      body.innerHTML = '<div class="oga-guide__chapter"><header class="oga-guide__heading"><span class="oga-guide__eyebrow">'+e(t('result_eyebrow'))+'</span><h2 tabindex="-1">'+e(t('result_title'))+'</h2><p class="oga-guide__sub">'+e(t('result_sub'))+'</p></header><ol class="oga-guide__results"></ol></div>';
      var list = body.querySelector('ol');
      result.forEach(function (item,index) {
        var li = document.createElement('li'); li.style.setProperty('--i',index);
        li.innerHTML = '<span class="oga-guide__result-number" aria-hidden="true">'+String(index+1).padStart(2,'0')+'</span><div class="oga-guide__image"></div><div class="oga-guide__product"><span class="oga-guide__brand">'+e(item.brand)+'</span><h3>'+e(item.title)+'</h3>'+noteMarkup(item)+'</div><div class="oga-guide__product-foot"><small>'+(item.premium?e(item.typeName||t('premium_label'))+' +'+e(money(item.surcharge)):e(t('included_label')))+'</small><button type="button" class="oga-guide__swap link" data-guide-swap="'+index+'" aria-label="'+e(t('swap')+' '+item.title)+'">'+e(t('swap'))+'</button></div>';
        var image = item.card.querySelector('[data-card-img] img');
        if (image) { var clone = image.cloneNode(true); clone.loading = 'eager'; li.querySelector('.oga-guide__image').appendChild(clone); }
        list.appendChild(li);
      });
      hint.innerHTML = variant && result.length === 5 ? '<span class="oga-guide__total-label">'+e(t('total'))+'</span><strong>'+e(money(variant.price))+'</strong><small>'+e(premium?premium+' '+t(premium===1?'premium_included_one':'premium_included'):t('no_surcharge'))+'</small>' : '';
      next.textContent = t('use_selection');
      next.disabled = result.length !== 5 || !variant || !variant.available || !inventoryReady();
      if (result.length !== 5) setNotice(inventoryReady()?t('not_enough'):t('stock_wait'));
      else if (options.selectedCount()) setNotice(t('replace_notice').replace('{count}',options.selectedCount()));
    }
    function goTo(index) { step = index; furthest = Math.max(furthest,step); render(); focusHeading(); }
    function createResult() {
      if (!inventoryReady()) {setNotice(t('stock_wait')); return;}
      result = selectFive(products(),answers,allowedCounts()); goTo(steps.length);
    }
    launch.addEventListener('click',function () {lastFocus=document.activeElement; closeSort(false); step=0; render(); dialog.showModal(); focusHeading();});
    dialog.querySelector('[data-guide-close]').addEventListener('click',function () {dialog.close();});
    dialog.addEventListener('close',function () {if(lastFocus && lastFocus.isConnected) lastFocus.focus({preventScroll:true});});
    journey.addEventListener('click',function (event) {var button=event.target.closest('[data-guide-jump]'); if(button && !button.disabled) goTo(Number(button.dataset.guideJump));});
    body.addEventListener('click',function (event) {
      var button=event.target.closest('[data-guide-answer]');
      if(button) {
        var current=steps[step], value=button.dataset.guideAnswer;
        if(current.multi) {
          var selected=values(answers[current.id]).slice();
          if(value==='any') selected=selected.includes('any')?[]:['any'];
          else {selected=selected.filter(function (v) {return v!=='any';}); if(selected.includes(value)) selected=selected.filter(function(v){return v!==value;}); else selected.push(value);}
          answers[current.id]=selected;
        } else answers[current.id]=value;
        furthest = Math.min(furthest,steps.length-1);
        setNotice(''); updateAnswers();
      }
      var swap=event.target.closest('[data-guide-swap]');
      if(swap) {
        if(!inventoryReady()) {setNotice(t('stock_wait')); return;}
        var index=Number(swap.dataset.guideSwap), fresh=replacement(products(),answers,result,index,allowedCounts());
        if(!fresh) {setNotice(t('no_alternative')); return;}
        result[index]=fresh; renderResult(); setNotice(t('swapped').replace('{name}',fresh.title)); body.querySelector('[data-guide-swap="'+index+'"]').focus({preventScroll:true});
      }
    });
    back.addEventListener('click',function () {goTo(Math.max(0,step-1));});
    next.addEventListener('click',function () {
      if(step<steps.length-1) {goTo(step+1); return;}
      if(step===steps.length-1) {
        var missing=steps.findIndex(function(s){return !values(answers[s.id]).length;});
        if(missing!==-1) {goTo(missing); return;}
        createResult(); return;
      }
      var current=new Map(products().map(function(p){return [p.id,p];}));
      var valid=result.length===5 && result.every(function(item){var p=current.get(item.id); return p && eligible(p,answers) && p.premium===item.premium && p.surcharge===item.surcharge;});
      if(!inventoryReady()) {setNotice(t('stock_wait')); return;}
      if(!valid) {result=selectFive(products(),answers,allowedCounts()); render(); setNotice(t('stock_changed')); return;}
      if(options.select(result.map(function(item){return item.card;}))===false) {setNotice(t('stock_changed')); return;}
      dialog.close(); var done=root.querySelector('[data-tray-done]'); if(done) done.focus({preventScroll:true});
    });
    root.querySelector('[data-self-search]').addEventListener('input',updateCatalog);
    root.querySelector('[data-self-filters]').addEventListener('click',function(event){if(event.target.closest('[data-filter]')) updateCatalog();});
    root.addEventListener('ornata:sample-inventory-ready',function(){updateCatalog(); if(dialog.open && step===steps.length){renderResult(); setNotice(t('stock_changed'));}});
    root.addEventListener('ornata:sample-inventory-error',function(){updateCatalog(); if(dialog.open && step===steps.length){next.disabled=true; setNotice(t('stock_wait'));}});
    updateCatalog();
  }
  var api = { mount:mount, selectFive:selectFive, replacement:replacement, profile:profile, notesFor:notesFor };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else scope.OrnataSampleGuide = api;
})(typeof window !== 'undefined' ? window : {});


